<template>
  <div>
    <section class="giteContainer actuItem">
      <router-link to="/actualites" name="page actualités">
        <i class="fal fa-arrow-circle-left"></i> Retour aux actus
      </router-link>

      <article v-if="$store.state.gbbuArticles">
        <img
          :src="buildImgUrl($store.state.gbbuArticles[currentArticle].idA, $store.state.gbbuArticles[currentArticle].pictureThumbA)"
          alt="actualité"
        />
        <div>
          <span
            class="dateSpan"
          >Le {{ returnDate( $store.state.gbbuArticles[currentArticle].datePublicationA) }}</span>
          <h2 class="titlePage">
            <strong>_</strong>
            {{ $store.state.gbbuArticles[currentArticle].titleA}}
            <strong>_</strong>
          </h2>

          <p>
            <b>{{ $store.state.gbbuArticles[currentArticle].titleSubA}}</b>
          </p>

          <div v-html="$store.state.gbbuArticles[currentArticle].describeA"></div>
        </div>
      </article>

      <div class="imgViewer" v-if="imgArray.length > 0">
        <transition name="imgFade">
          <div class="bigsmallsImgBoxEl">
            <div class="theBlurStyle">
              <img :src="imgArray[imgToCatch]" alt="Gite en lebé" :key="imgToCatch" />
            </div>
            <img :src="imgArray[imgToCatch]" class="theBigImg" alt="Gite en lebé" :key="imgToCatch" />

            <div class="arrowNavActu left" @click="nav(-1)">
              <i class="fas fa-angle-left fa-2x"></i>
            </div>
            <div class="arrowNavActu right" @click="nav(1)">
              <i class="fas fa-angle-right fa-2x"></i>
            </div>
          </div>
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageId: "",
      currentArticle: 0,
      imgArray: [],
      urlImage:
        "https://cdn-gbbu02.graphibox.eu/pub/" +
        this.$store.state.globalData.siteId +
        "/medias/articles/",
      imgToCatch: 0,
    };
  },
  components: {},
  mounted() {
    this.pageId = this.$route.params.id;

    if (this.$store.state.gbbuArticles) {
      for (let i = 0; i < this.$store.state.gbbuArticles.length; i++) {
        if (this.pageId == this.$store.state.gbbuArticles[i].idA) {
          this.currentArticle = i;
        }
      }
      this.filImgArray(this.currentArticle);
    }
  },
  watch: {},

  methods: {
    getImg(img) {
      return require("@/assets/images/" + img);
    },
    nav(direction) {
      let nextValue = this.imgToCatch + direction;
      if (nextValue >= this.imgArray.length) {
        nextValue = 0;
      } else if (nextValue < 0) {
        nextValue = this.imgArray.length - 1;
      }
      this.imgToCatch = nextValue;
    },

    buildImgUrl(id, img) {
      return this.urlImage + id + "/" + img;
    },
    returnDate(date) {
      let a = new Date(date);
      const month = a.toLocaleString("default", { month: "long" });
      return a.getDay() + " " + month + " " + a.getFullYear();
    },
    splitExtrait(title, description) {
      let val = title + "<br/>" + description;
      if (val.length > 140) {
        val = val.substring(0, 140) + "...";
      }
      return val;
    },
    filImgArray(i) {
      if (this.$store.state.gbbuArticles[i].picture01A !== null) {
        this.imgArray.push(
          this.buildImgUrl(
            this.pageId,
            this.$store.state.gbbuArticles[i].picture01A
          )
        );
      }
      if (this.$store.state.gbbuArticles[i].picture02A !== null) {
        this.imgArray.push(
          this.buildImgUrl(
            this.pageId,
            this.$store.state.gbbuArticles[i].picture02A
          )
        );
      }
      if (this.$store.state.gbbuArticles[i].picture03A !== null) {
        this.imgArray.push(
          this.buildImgUrl(
            this.pageId,
            this.$store.state.gbbuArticles[i].picture03A
          )
        );
      }
      if (this.$store.state.gbbuArticles[i].picture04A !== null) {
        this.imgArray.push(
          this.buildImgUrl(
            this.pageId,
            this.$store.state.gbbuArticles[i].picture04A
          )
        );
      }
      if (this.$store.state.gbbuArticles[i].picture05A !== null) {
        this.imgArray.push(
          this.buildImgUrl(
            this.pageId,
            this.$store.state.gbbuArticles[i].picture05A
          )
        );
      }
      if (this.$store.state.gbbuArticles[i].picture06A !== null) {
        this.imgArray.push(
          this.buildImgUrl(
            this.pageId,
            this.$store.state.gbbuArticles[i].picture06A
          )
        );
      }
      if (this.$store.state.gbbuArticles[i].picture07A !== null) {
        this.imgArray.push(
          this.buildImgUrl(
            this.pageId,
            this.$store.state.gbbuArticles[i].picture07A
          )
        );
      }
      if (this.$store.state.gbbuArticles[i].picture08A !== null) {
        this.imgArray.push(
          this.buildImgUrl(
            this.pageId,
            this.$store.state.gbbuArticles[i].picture08A
          )
        );
      }
    },
  },
};
</script>


<style>
.actuItem {
}
.actuItem article {
  display: flex;
  margin: 1rem 0;
}
.actuItem article > img {
  margin-right: 2rem;
  max-width: 30%;
  max-height: 90vh;
  object-fit: cover;
}
.dateSpan {
  color: var(--main-color);
  text-transform: uppercase;
  font-weight: 700;
}
.actuItem h2::first-letter {
  font-size: 1.4em;
}
.actuItem a {
  font-size: 1.2em;
  color: var(--main-color);
}
.actuItem a:hover {
  color: var(--dark-color);
}
.bigsmallsImgBoxEl {
  height: 60vh;
  margin-bottom: 1rem;
  overflow: hidden;
  position: relative;
}
.theBlurStyle {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  overflow: hidden;
}
.theBlurStyle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(16px);
  -webkit-filter: blur(16px);
  transform: scale(1.2);
}
.theBigImg {
  height: 100%;
  width: 100%;
  object-fit: contain;
  transition: all 0.5s ease;
  z-index: 1;
  position: relative;
}

.arrowNavActu {
  position: absolute;
  color: white;
  cursor: pointer;
  font-size: 3em;
  right: 0;
  top: 0;
  height: 100%;
  width: 50%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s all ease;
}
.left {
  right: unset;
  left: 0;
}
.left i {
  margin-right: 30%;
}

.left:hover {
  background: rgba(204, 204, 204, 0.2);
  background: linear-gradient(
    90deg,
    rgba(204, 204, 204, 0.45) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  transition: 1s all ease;
}
.right i {
  margin-left: 30%;
}
.right:hover {
  /* background: rgba(204, 204, 204, 0.2); */
  background: linear-gradient(
    270deg,
    rgba(204, 204, 204, 0.45) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  transition: 0.3s all ease;
}
.situationText {
  font-size: 1.1rem;
}

.situationText a {
  text-decoration: underline;
  text-decoration-color: dimgray;
}
.imgFade-enter-active,
.imgFade-leave-active {
  transition: opacity 0.5s;
}
.imgFade-leave-to {
  display: none;
}
.imgFade-enter {
  opacity: 0.8;
}
@media all and (max-width: 1000px) {
  .actuItem article {
    flex-direction: column;
  }
  .actuItem article > img {
    margin-right: 0;
    max-width: 100%;
    max-height: 25vh;
  }
  .actuItem > a {
    margin-top: 1rem;
    display: block;
  }
}
</style>